import React, { useContext, useState } from 'react';
import './SingleOption.scss';
import { layoutContext } from '../CODBGame';
import { Help16 } from '@carbon/icons-react';

interface singleOptionProps {
  options: any[];
  helpLabel: string;
}

const SingleOption = (sOMProps: singleOptionProps) => {
  const { options, helpLabel } = sOMProps;
  const {
    setSelectedOption,
    watsonButton,
    showPercentageButton,
    doublechancedisableclassname,
  } = useContext(layoutContext);

  const [selectedRadio, setSelectedRadio] = useState(-1);

  const [watson] = useState(true);

  const handleOptionChange = (item: any, index: number) => {
    setSelectedRadio(index);
    setSelectedOption(item);
  };

  return (
    <div className="codb-game__single-option-container">
      {options.map((option: any, i: number) => (
        <>
          <div className="bx--row">
            {/* se for adicionar o wrapper aqui, pode criar uma nova camada e deixar essa class bx--row sozinha msm */}
            {/* Aí seria só criar uma div aqui dentro pra encapsular tudo numa so */}
            <div
              key={option.id}
              className={` codb-game__single-option bx--col-lg-14 bx--col-md-7 bx--col-sm-4 ${
                selectedRadio === i ? 'codb-game__single-option-selected' : ''
              }`}
              style={{ paddingRight: 0 }}
              onClick={() => handleOptionChange(option, i)}
            >
              <div
                className={`${
                  selectedRadio === i
                    ? 'codb-game__single-option-card_selected'
                    : 'codb-game__single-option-card'
                } ${
                  option.correctAnswer != 1 && i != 3
                    ? i === 2 && options[3].correctAnswer === 1
                      ? 'appearedclass'
                      : doublechancedisableclassname
                    : 'appearedclass'
                } `}
              >
                <div className="codb-game__single-option-text">
                  {option.text}
                </div>
              </div>
            </div>
            <div
              className="codb-game__aiWatson-container bx--col-lg-1 bx--col-md-1 bx--col-sm-4"
              style={{ padding: 0 }}
            >
              <div className="codb-game__aiWatson-container-wrapper">
                {watsonButton &&
                showPercentageButton !== null &&
                option.correctAnswer === 1 &&
                watson ? (
                  <div className="codb-game__aiWatson-container-help">
                    <div className="codb-game__aiWatson-container-help-percentage">
                      {helpLabel}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </>
      ))}
    </div>
  );
};

export default SingleOption;
